import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Shield, Building2, IndianRupee, TrendingUp, Users } from "lucide-react";

function Kpi({ label, value, icon: Icon, tone }) {
  return (
    <div className="glass rounded-lg p-5">
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">{label}</span>
        <Icon className={`w-4 h-4 ${tone || "text-orange-400"}`} />
      </div>
      <div className="text-3xl font-extrabold mt-2">{value}</div>
    </div>
  );
}

export default function AdminSubscriptions() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/subscriptions").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-500">Loading…</div>;
  const { rows, kpis } = data;

  return (
    <div className="space-y-6" data-testid="admin-subscriptions-page">
      <div>
        <div className="text-xs text-gray-500 flex items-center gap-1"><Shield className="w-3 h-3" strokeWidth={2.5} /> Platform Admin</div>
        <h1 className="text-3xl md:text-4xl font-extrabold">Org Subscriptions</h1>
        <p className="text-sm text-gray-500 mt-1">Cross-tenant subscription overview · {kpis.total_orgs} orgs</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        <Kpi label="Total MRR" value={`₹${kpis.total_mrr.toLocaleString("en-IN")}`} icon={IndianRupee} />
        <Kpi label="Active" value={kpis.active} icon={TrendingUp} tone="text-emerald-400" />
        <Kpi label="Trial" value={kpis.trial} icon={Users} tone="text-sky-400" />
        <Kpi label="Cancelled" value={kpis.cancelled} icon={Users} tone="text-red-400" />
        <Kpi label="Total Orgs" value={kpis.total_orgs} icon={Building2} />
      </div>

      <div className="glass p-6 rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-wider text-gray-500">
            <tr>
              <th className="text-left pb-2">Org</th>
              <th className="text-left pb-2">Plan</th>
              <th className="text-left pb-2">Status</th>
              <th className="text-right pb-2">MRR</th>
              <th className="text-left pb-2">Next Billing</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.subscription_id} className="border-t border-gray-200 hover:bg-gray-50">
                <td className="py-2.5">
                  <div className="font-semibold">{r.org_name}</div>
                  <div className="text-[10px] text-gray-500">{r.org_id}</div>
                </td>
                <td>{r.plan_name}</td>
                <td><span className={`px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest font-bold ${r.status === "active" ? "bg-emerald-500/20 text-emerald-700" : "bg-amber-50 border border-amber-200 text-amber-700"}`}>{r.status}</span></td>
                <td className="text-right font-bold">₹{(r.mrr_inr || 0).toLocaleString("en-IN")}</td>
                <td className="text-xs text-gray-500">{r.next_billing_date ? new Date(r.next_billing_date).toLocaleDateString() : "—"}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="text-center text-gray-500 py-6">No subscriptions yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
